import React, { Component } from "react";
import { push } from "../Services/Analytics"

import "./Welcome.scss"

class Welcome extends Component {
  constructor() {
    super()
    this.state = {
    }
  }
  render() {
    return (
      <section className="section section-welcome">
        <div className="padding">
          <div className="container">
            <div className="headline">
              <div className="head">תחרות העסקים הקטנים 12</div>
              <div className="subtitle">מי יהיה חביב הקהל? בואו לבחור את העסק
האהוב עליכם</div>
              <div className="desc">
                <span>
                מתוך מאות עסקים שהגישו מועמדות, 9 עסקים הגיעו השנה לשלב הגמר: 6 מהם במסלול העסקי ו-3 במסלול החברתי. כעת גם אתם יכולים להשפיע - בואו להכיר את העסקים המובילים ולבחור את העסק האהוב עליכם.  
                </span>
                {/* <br /><br />
                חקלאות, אופנה, תיירות או מזון – מאות בעלי עסקים ומיזמים ממגוון תחומים והתמחויות, השתתפו בתחרות העסקים הקטנים של "ידיעות אחרונות", ynet
ובנק הפועלים. 11 מתוכם העפילו לשלב הנבחרת וזכו בליווי מקצועי ומקיף. כעת הגיע תורכם להשפיע. בואו להכיר את העסקים המובילים ולבחור את העסק שאתם הייתם מעדיפים לראות בשורה הראשונה.
העסקים הזוכים ייהנו מחבילת פרסום ב"ידיעות אחרונות," או ב־ynet ו"מענק יזמות" בשווי 10 אלף שקל. העסק שיבחר כחביב הקהל יהנה מחבילת פרסום ומענק יזמות של 5,000 שקל. */}
                <p className="star"><b style={{color: "red"}}>*</b> בכפוף לתקנון התחרות</p>
              </div>
              <div className="goforit">
                בחרו את העסק שלכם
              </div>
              <div className="waves"></div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/Components/Welcome/Welcome.jsx